// import { Swiper, SwiperSlide } from 'swiper/react';
// import "swiper/swiper-bundle.css";
// import { Pagination, Autoplay } from 'swiper/modules';

// import homeimg1 from "../assest/images/homeimg1.png";
// import homeimg2 from "../assest/images/homeimg2.png";
// import homeimg3 from "../assest/images/homeimg3.png";
import helper, { isMobile } from '../common/Helper';
import ContentLoader from 'react-content-loader';


const LocationMainBannerSection = ({ 
    locationDetail, 
    isLoading,

    handleKeyUp,
    searchValue,
    setSearchValue,
    onClickReset,
    isSearchLoading,
    productsSuggetion,
    activitiesSuggetion,
    destinationSuggetions,
    onClickProduct,
    onClickDestination,
    onClickActivity

 }) => {

    let locImg = helper.S3Url + '/' + helper.locationImageDir + '/' + (locationDetail?.image ? locationDetail?.image : locationDetail?.listing_image);
    let MobImg = helper.S3Url + '/' + helper.locationImageDir + '/' + (locationDetail?.listing_image ? locationDetail?.listing_image : locationDetail?.image);


    return (
      
        <>
            {
                isLoading ?
                    // <div className="container-fluid">
                        <ContentLoader
                            backgroundColor="#e0e0d9"
                            foregroundColor="#d6d6d0"
                            viewBox={`0 0 ${window.innerWidth} 490`}
                            width="100%"
                            height="490"
                        >
                            <rect x="0" y="0" rx="0" ry="0" width="100%" height="490" />
                        </ContentLoader>
                    // </div>
                    :
                    <>
                       
                        {/* <section className="mainBanner" style={{ backgroundImage: `url(${locImg})` }}> */}
                        <section className="mainBanner" style={{ backgroundImage: `url(${isMobile() ? MobImg : locImg})` }}>
                            <div className="bannerBox">
                                <div className="container">
                                    <div className="bannerText">
                                        <div className="sliderText">
                                             <h2>{locationDetail?.name}</h2>
                                            <p>{locationDetail?.short_description}</p>
                                        </div>
                                        {/* <div className="typeBox search-group">
                                            <input
                                                type="search"
                                                className="clickList"
                                                onKeyUp={handleKeyUp}
                                                value={searchValue}
                                                onChange={(e) => setSearchValue(e.target.value)} // Update state
                                                placeholder="Where are you travelling to?"
                                            />
                                            <div className={`search-key ${(searchValue === "" || searchValue.trim().length < 3) ? "d-none" : ""}`}>
                                                {
                                                    isSearchLoading &&
                                                    <div className={"preloader"} style={{ position: "absolute" }}>
                                                        <div className="preloader-icon"></div>
                                                    </div>
                                                }
                                                {
                                                    productsSuggetion.length === 0 && activitiesSuggetion.length === 0 && destinationSuggetions.length === 0 &&
                                                    <ul>
                                                        <li>
                                                            <span href="javascript:void(0)">{isSearchLoading ? 'Searching...' : 'No results found'}</span>
                                                        </li>
                                                    </ul>
                                                }
                                                {
                                                    destinationSuggetions.length > 0 &&
                                                    <ul>

                                                        <h6><i className="fa-solid fa-location-dot"></i>Destinations</h6>
                                                        {
                                                            destinationSuggetions.map((destination, index) => {
                                                                return (
                                                                    <li key={index}>
                                                                        <a href="javascript:void(0)" onClick={() => onClickDestination(destination.name)}>{destination.name}
                                                                            {
                                                                                destination?.parent_name &&
                                                                                <span>{destination?.parent_name}</span>
                                                                            }
                                                                        </a>
                                                                    </li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                }

                                                <ul>
                                                    {
                                                        (productsSuggetion.length > 0 || activitiesSuggetion.length) > 0 &&
                                                        <h6><i className="fa-solid fa-bolt"></i>Аctivities</h6>
                                                    }

                                                    {
                                                        activitiesSuggetion.map((activity, index) => {
                                                            return (
                                                                <li key={index}>
                                                                    <a href="javascript:void(0)" onClick={() => onClickActivity(activity.slug)}>{activity.name}
                                                                    </a>
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                    {
                                                        productsSuggetion.map((product, index) => {
                                                            const productLocation = product?.location ? JSON.parse(product.location) : null;
                                                            const spacedValues = productLocation ? Object.values(productLocation).join(', ') : '';
                                                            return (
                                                                <li key={index}>
                                                                    <a href="javascript:void(0)" onClick={() => onClickProduct(product.slug)}>{product.title}
                                                                        {
                                                                            product?.location &&
                                                                            <span>{spacedValues}</span>
                                                                        }
                                                                    </a>
                                                                </li>
                                                            )
                                                        })
                                                    }

                                                </ul>
                                            </div>
                                            <div className="sendBtn">
                                                {
                                                    searchValue.trim().length > 0 ?
                                                        <button onClick={onClickReset} className="btn btnSend crossBtn"><i className="fa-solid fa-close"></i></button>
                                                        :
                                                        <button className="btn btnSend"><i className="fa-solid fa-arrow-right"></i></button>
                                                }

                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </section>
                    </>
            }



        </>
    )
}
export default LocationMainBannerSection;